import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AuthenticatedGuard } from '../guards/authenticated.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then(
        (module) => module.NgxAuthModule,
      ),
  },
  {
    path: '',
    canActivate: [AuthenticatedGuard],
    loadChildren: () =>
      import('./modules/main/main.module').then(
        (module) => module.NgxMainModule,
      ),
  },
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

const config: ExtraOptions = {
  useHash: false,
  relativeLinkResolution: 'legacy',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
  providers: [AuthenticatedGuard],
})
export class AppRoutingModule {}
